const InputWithOutLabels = ({ type, placeholder, value, onChange, cn = "" }) => {
  return (
    <div className={`${cn}`}>
      <input
        type={type}
        className="form-control height-25 p-0 p-l-5 "
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default InputWithOutLabels;
